module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_InternationalFranchises_03-db8106a89bd61296eb93b2c2e654be0e.jpg";